import React from 'react';
import { NavLink } from 'react-router-dom';
import { TopMenuStyle } from './Style';

import {
    ProjectOutlined,
    ProfileOutlined,
    CheckSquareOutlined,
    FileTextOutlined,
    CalendarOutlined,
    CoffeeOutlined,
    ScheduleOutlined
} from '@ant-design/icons';

function StudentTopMenu() {
    const path = '/employee';

    const iconStyle = { marginRight: -5, fontSize: 16 };

    return (
        <TopMenuStyle>
            <div className="ninjadash-top-menu">
                <ul>
                    {/* <li>
                        <NavLink to={`${path}/projects`}>
                            <ProjectOutlined style={iconStyle} />
                            Projects
                        </NavLink>
                    </li> */}

                    {/* <li>
                        <NavLink to={`${path}/task-manager`}>
                            <ProfileOutlined style={iconStyle} />
                            Task Manager
                        </NavLink>
                    </li> */}

                    <li>
                        <NavLink to={`${path}/mytasks`}>
                            <CheckSquareOutlined style={iconStyle} />
                            My Tasks
                        </NavLink>
                    </li>
                    {/* 
                    <li>
                        <NavLink to={`${path}/requirements`}>
                            <FileTextOutlined style={iconStyle} />
                            Requirements
                        </NavLink>
                    </li> */}

                    <li>
                        <NavLink to={`${path}/todo`}>
                            <CoffeeOutlined style={iconStyle} />
                            Todo
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/StatusReport`}>
                            <CalendarOutlined style={iconStyle} />
                            Status Report
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to={`${path}/leave`}>
                            <ScheduleOutlined style={iconStyle} />
                            Leaves
                        </NavLink>
                    </li>
                </ul>
            </div>
        </TopMenuStyle>
    );
}

export default StudentTopMenu;
